import React from 'react';
import styles from './FormattingToolbar.module.css';

const FormattingToolbar = ({ onFormat }) => {
  return (
    <div className={styles.toolbar}>
      <button onClick={() => onFormat('b')}><b>B</b></button>
      <button onClick={() => onFormat('i')}><i>I</i></button>
      <button onClick={() => onFormat('u')}><u>U</u></button>
      <button onClick={() => onFormat('mark')}>🔆</button>
    </div>
  );
};

export default FormattingToolbar;
